import type { WrapUpTimeEndedEventPublisher } from '@usecases/wrap-up-time-ended.usecase';
import { BusIframe } from '@main/bus-layer/bus-iframe';
import type { BusEvent } from '@main/utils/bus-event-promisifier';
import { BusEventsPromisifier } from '@main/utils/bus-event-promisifier';
import { Logger } from '@main/utils/logger';

export class WrapUpTimeEndedPublisher implements WrapUpTimeEndedEventPublisher {
  private logger: Logger;
  constructor() {
    this.logger = new Logger();
  }
  async publish(): Promise<void> {
    const busIframe = await BusIframe.getIframe();
    this.logger.info('Publisher: Wrap Up Time Ended', {
      action: 'WrapUpTimeEnded',
    });
    const busEvent: BusEvent = {
      type: 'API.DELETE_WRAPUP_TIME',
    };
    BusEventsPromisifier.promisifyFireAndForgetEvent({
      target: busIframe,
      event: busEvent,
    });
  }
}
